import React, {Component} from 'react'

import TextField from '@material-ui/core/TextField'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import TemplatesPanel from "./CreateShowDialog/TemplatesPanel"
import ArtistsPanel from "./CreateShowDialog/ArtistsPanel"
import SelectTemplateDialog from "./../../templates/SelectTemplateDialog"
import TemplateAmountDialog from "./CreateShowDialog/TemplateAmountDialog.js"
import SelectUserDialog from "./../../users/SelectUserDialog"
import CodeNotFoundDialog from './CreateShowDialog/CodeNotFoundDialog.js'

import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'

import Button from '@material-ui/core/Button'
import { MenuItem } from '@material-ui/core'

import {
	Grid,
} from '@material-ui/core'

import api from '../../api.js'

/**
 * <CreateShowDialog onCreateShow = {show} onCancel = {} />
 */

class CreateShowDialog extends Component {

	constructor(props) {

		super(props)

		this.state = {
			dialog: undefined,
			name: "",
			date: this.getCurrentDate(),
			time: this.getCurrentTime(),
			address: "",
			templates: [],
			artists: [],
			boxBig: 1,
			boxMedium: 1,
			box_code: "",
		}

		super(props)
		this.handleSelectTemplateClick = this.handleSelectTemplateClick.bind(this)
		this.handleRemoveTemplateClick = this.handleRemoveTemplateClick.bind(this)
		this.handleSelectArtistClick = this.handleSelectArtistClick.bind(this)
		this.handleRemoveArtistClick = this.handleRemoveArtistClick.bind(this)
		this.handleBoxBigSelectChange = this.handleBoxBigSelectChange.bind(this)
		this.handleboxMediumSelectChange = this.handleboxMediumSelectChange.bind(this)
	}

	getCurrentDate() {
		let date = new Date()
		let year = date.getFullYear()
		let month = date.getMonth() + 1
		let day = date.getDate()
		return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
	}

	getCurrentTime() {
		let date = new Date()
		let hours = date.getHours()
		let minutes = date.getMinutes()
		return `${hours < 10 ? `0${hours}` : `${hours}`}:${minutes < 10 ? `0${minutes}` : `${minutes}`}`
	}

	normalizeTime(time) {
		if (typeof time === "string") {
			switch (time.length) {
				case 5:
					return `${time}:00`
				case 8:
					return time
				default:
					return "00:00:00"
			}
		}
		return "00:00:00"
	}

	readyToCreate() {
		if (this.state.name === "") {
			return false
		}
		if (this.state.address === "") {
			return false
		}
		if (!this.state.artists.length) {
			return false
		}
		return true
	}

	handleSelectTemplateClick() {
		this.setState({
			dialog: <SelectTemplateDialog
				onSelectTemplate = {template => {
					this.setState({
						dialog: <TemplateAmountDialog
							template = {template}
							amount = {1}
							onSetAmount = {(template, amount) => {
								template.amount = amount
								this.state.templates.push(template)
								if (this.state.name === "") {
									this.setState({
										name: template.name
									})
								}
								this.setState({dialog: undefined})
							}}
							onCancel = {() => this.setState({dialog: undefined})}
						/>
					})
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleRemoveTemplateClick(template) {
		this.setState({templates: this.state.templates.filter(t => t !== template)})
	}

	handleSelectArtistClick() {
		// filter = {[4]} - показать только ведущих.
		this.setState({
			dialog: <SelectUserDialog
				title = "Добавить ведущего"
				filter = {[4]}
				onSelectUser = {user => {
					this.state.artists.push(user)
					this.setState({dialog: undefined})
				}}
				onCancel = {() => this.setState({dialog: undefined})}
			/>
		})
	}

	handleRemoveArtistClick(artist) {
		this.setState({
			artists: this.state.artists.filter(a => a !== artist),
		})
	}

	handleBoxBigSelectChange(event) {
		this.setState({
			boxBig: event.target.value
		})
	}

	handleboxMediumSelectChange(event) {
		this.setState({
			boxMedium: event.target.value
		})
	}

	render() {

		if (this.state.dialog) {
			return this.state.dialog
		}

		return <Dialog
			open = {true}
			fullWidth = {true}
		>

			<DialogTitle>
				Создать шоу
			</DialogTitle>

			<DialogContent 
				style = {{display: "flex", flexDirection: "column"}}
			>

				<TemplatesPanel
					templates = {this.state.templates}
					onSelectTemplateClick = {this.handleSelectTemplateClick}
					onRemoveTemplateClick = {this.handleRemoveTemplateClick}
				/>

				<ArtistsPanel
					artists = {this.state.artists}
					onSelectArtistClick = {this.handleSelectArtistClick}
					onRemoveArtistClick = {this.handleRemoveArtistClick}
				/>

				<TextField
					value = {this.state.name}
					label = "Название шоу"
					margin = "normal"
					onChange = {e => {
						e.stopPropagation()
						this.setState({
							name: e.target.value
						})
					}}
				/>

				<TextField
					label = "Адрес проведения"
					value = {this.state.address}
					margin = "normal"
					onChange = {e => {
						e.stopPropagation()
						this.setState({ address: e.target.value })
					}}
				/>

				<TextField 
					label="Код коробки"
					value={this.state.box_code}
					margin='normal'
					onChange={e => {
						e.stopPropagation()
						this.setState({ box_code: e.target.value })
					}}
				/>

				{/* <Grid
					item
					container
				>
					<Grid
						item
						xs = {6}
						style = {{display: 'flex', flexDirection: 'column'}}
					>
						<FormControl
							margin = "normal"
						>
							<InputLabel id="boxBig_select_label">Ящик большой</InputLabel>
							<Select
								label = "Select"
								value = {this.state.boxBig}
								onChange = {this.handleBoxBigSelectChange}
							>
								<MenuItem value = {0}>0</MenuItem>
								<MenuItem value = {1}>1</MenuItem>
								<MenuItem value = {2}>2</MenuItem>
								<MenuItem value = {3}>3</MenuItem>
								<MenuItem value = {4}>4</MenuItem>
								<MenuItem value = {5}>5</MenuItem>
								<MenuItem value = {6}>6</MenuItem>
								<MenuItem value = {7}>7</MenuItem>
								<MenuItem value = {8}>8</MenuItem>
								<MenuItem value = {9}>9</MenuItem>
								<MenuItem value = {10}>10</MenuItem>
								<MenuItem value = {11}>11</MenuItem>
								<MenuItem value = {12}>12</MenuItem>
								<MenuItem value = {13}>13</MenuItem>
								<MenuItem value = {14}>14</MenuItem>
								<MenuItem value = {15}>15</MenuItem>
								<MenuItem value = {16}>16</MenuItem>
								<MenuItem value = {17}>17</MenuItem>
								<MenuItem value = {18}>18</MenuItem>
								<MenuItem value = {19}>19</MenuItem>
								<MenuItem value = {20}>20</MenuItem>
								<MenuItem value = {21}>21</MenuItem>
								<MenuItem value = {22}>22</MenuItem>
								<MenuItem value = {23}>23</MenuItem>
								<MenuItem value = {24}>24</MenuItem>
								<MenuItem value = {25}>25</MenuItem>
								<MenuItem value = {26}>26</MenuItem>
								<MenuItem value = {27}>27</MenuItem>
								<MenuItem value = {28}>28</MenuItem>
								<MenuItem value = {29}>29</MenuItem>
								<MenuItem value = {30}>30</MenuItem>
								<MenuItem value = {31}>31</MenuItem>
								<MenuItem value = {32}>32</MenuItem>
								<MenuItem value = {33}>33</MenuItem>
								<MenuItem value = {34}>34</MenuItem>
								<MenuItem value = {35}>35</MenuItem>
								<MenuItem value = {36}>36</MenuItem>
								<MenuItem value = {37}>37</MenuItem>
								<MenuItem value = {38}>38</MenuItem>
								<MenuItem value = {39}>39</MenuItem>
								<MenuItem value = {40}>40</MenuItem>
							</Select>
						</FormControl>						
					</Grid>
					<Grid
						item
						xs = {6}
						style = {{display: 'flex', flexDirection: 'column'}}
					>
						<FormControl
							margin = "normal"
						>
							<InputLabel id="boxMedium_select_label">Ящик средний</InputLabel>
							<Select
								label = "Select"
								value = {this.state.boxMedium}
								onChange = {this.handleboxMediumSelectChange}
							>
								<MenuItem value = {0}>0</MenuItem>
								<MenuItem value = {1}>1</MenuItem>
								<MenuItem value = {2}>2</MenuItem>
								<MenuItem value = {3}>3</MenuItem>
								<MenuItem value = {4}>4</MenuItem>
								<MenuItem value = {5}>5</MenuItem>
								<MenuItem value = {6}>6</MenuItem>
								<MenuItem value = {7}>7</MenuItem>
								<MenuItem value = {8}>8</MenuItem>
								<MenuItem value = {9}>9</MenuItem>
								<MenuItem value = {10}>10</MenuItem>
								<MenuItem value = {11}>11</MenuItem>
								<MenuItem value = {12}>12</MenuItem>
								<MenuItem value = {13}>13</MenuItem>
								<MenuItem value = {14}>14</MenuItem>
								<MenuItem value = {15}>15</MenuItem>
								<MenuItem value = {16}>16</MenuItem>
								<MenuItem value = {17}>17</MenuItem>
								<MenuItem value = {18}>18</MenuItem>
								<MenuItem value = {19}>19</MenuItem>
								<MenuItem value = {20}>20</MenuItem>
							</Select>
						</FormControl>
					</Grid>
				</Grid> */}

				<Grid
					item
					container
				>
					<Grid
						item
						xs = {6}
						style = {{display: 'flex', flexDirection: 'column'}}
					>
						<TextField
							margin = "normal"
							label = "Дата проведения"
							type = "date"
							value = {this.state.date}
							onChange = {e => {
								e.stopPropagation()
								this.setState({
									date: e.target.value
								})
							}}
						/>
					</Grid>
					<Grid
						item
						xs = {6}
						style = {{display: 'flex', flexDirection: 'column'}}
					>
						<TextField
							margin = "normal"
							label = "Время проведения"
							type = "time"
							value = {this.state.time}
							onChange = {e => {
								e.stopPropagation()
								this.setState({
									time: e.target.value
								})
							}}
						/>
					</Grid>
				</Grid>

			</DialogContent>

			<DialogActions>

				<Button
					disabled = {!this.readyToCreate()}
					onClick = {async (e) => {
						
						e.stopPropagation()

						let { box } = await api.boxes.get_byCode(this.state.box_code)

						if (box.id > 0) {
							if (typeof this.props.onCreateShow === "function") {
								this.props.onCreateShow({
									name: this.state.name,
									templates: this.state.templates,
									address: this.state.address,
									date: `${this.state.date} ${this.normalizeTime(this.state.time)}`,
									artists: this.state.artists,
									boxBig: this.state.boxBig,
									boxMedium: this.state.boxMedium,
									box_id: box.id,
								})
							}
						} else {
							this.setState({
								dialog: <CodeNotFoundDialog
									code={this.state.box_code}
									onClose={()=>{
										this.setState({dialog: undefined})
									}}
								/>
							})
						}
						
					}}
				>Создать</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default CreateShowDialog
